import { useCallback } from 'react';
import { navigationService } from '@lib/services/other/navigationService.ts';
import { getCurrentPlanFromPaymentStatus, effectivePlanStatus } from '@lib/services/payment/planUtils';
import { usePaymentNotifications } from '@hooks/usePaymentNotifications.ts';
import { useAuthStore } from '@stores/authStore.ts';
export function PaymentNotificationListener() {
  const refreshUserFromServer = useAuthStore(state => state.refreshUserFromServer);

  const handlePaymentStatusChange = useCallback(
    async (oldStatus: string, newStatus: string) => {
      console.log('Payment status change detected:', { oldStatus, newStatus });
      const onPaymentFlow = window.location.pathname.startsWith('/payment');
      if (!onPaymentFlow) return;
      // Re-fetch the user so we see the authoritative plan: credit (ai_*) purchases
      // leave paymentStatus = "unpaid" (the notification's newStatus), so the real
      // signal is creditPlanCode — resolve via effectivePlanStatus. Navigate whenever
      // a paid plan is now active. PaymentForm navigates on success; this is the
      // backup for cases where it didn't (e.g. Shopify return / re-opened tab).
      const fresh = await refreshUserFromServer();
      const isNowPaid = getCurrentPlanFromPaymentStatus(effectivePlanStatus(fresh) ?? '') !== null;
      if (isNowPaid) {
        navigationService.navigateTo('/ai-team');
      }
    },
    [refreshUserFromServer]
  );

  usePaymentNotifications(
    {
      timeWindowMs: 30 * 60 * 1000, // 30 minutes
      includeMetadataChanges: false,
      source: 'default',
    },
    handlePaymentStatusChange
  );

  // This component doesn't render anything, it just handles the hook
  return null;
}
